import React, { FormEvent } from 'react';
import { Modal } from 'shared/components/inputModal/modal';


type CreateCourseModalProps = {
  createCourseGroup: (e: FormEvent<HTMLFormElement>) => Promise<void>;
  onChange: React.Dispatch<React.SetStateAction<string>>;
  setShowCreateCourseModal: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CreateCourseModal = ({
  createCourseGroup, onChange, setShowCreateCourseModal,
}: CreateCourseModalProps) => (
  <Modal>
    <h1>Cursus toevoegen</h1>
    <form onSubmit={createCourseGroup}>
      <input className="input" placeholder="Cursus versie" type="text" name="createCourseName" onChange={(e) => onChange(e.target.value)} />
      <div className="button_div">
        <button className="modal_button_secondary" type="button" onClick={() => setShowCreateCourseModal(false)}>Annuleren</button>
        <button className="modal_button_primary" type="submit">Verstuur</button>
      </div>
    </form>
  </Modal>
);
